<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
  }>(),
  {
    label: 'ENTRAR',
    disabled: false,
    type: 'submit',
  },
);
</script>

<template>
  <button
    class="w-full px-4 py-2 rounded-xl inline-flex justify-center items-center gap-2 transition bg-[#ff3700] text-white hover:brightness-110"
    :disabled="disabled"
    :type="type"
  >
    <span
      class="text-center justify-center text-white text-base font-medium leading-6"
    >
      {{ label }}
    </span>
  </button>
</template>
